import { render } from "./helpSupport.vue?vue&type=template&id=aba80b82&scoped=true"
import script from "./helpSupport.vue?vue&type=script&lang=js"
export * from "./helpSupport.vue?vue&type=script&lang=js"

import "./helpSupport.vue?vue&type=style&index=0&id=aba80b82&scoped=true&lang=css"
import "./helpSupport.vue?vue&type=style&index=1&id=aba80b82&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba80b82"]])

export default __exports__